
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories-with-questions",
      function () {
        return require("private-next-pages/stories-with-questions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories-with-questions"])
      });
    }
  